import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
	// Help diagnose 401s early during local dev/build
	// eslint-disable-next-line no-console
	console.warn('[Supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. API calls will fail with 401 Unauthorized.');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

// Convenience auth helpers for the app (optional use)
export const supabaseAuth = {
	getSession: () => supabase.auth.getSession(),
	signInWithOtp: (email) => supabase.auth.signInWithOtp({ email }),
	// Allow identifier to be email or username; if username, resolve to email via profiles
	signInWithIdentifierOtp: async (identifier) => {
		let email = identifier;
		if (typeof identifier === 'string' && !identifier.includes('@')) {
			const { data, error } = await supabase.rpc('auth_resolve_email', { identifier });
			if (error || !data) throw new Error('Usuario no encontrado');
			email = data;
		}
		return supabase.auth.signInWithOtp({ email });
	},
	// Classic username/email + password login
	signInWithPasswordIdentifier: async (identifier, password) => {
		let email = identifier;
		if (typeof identifier === 'string' && !identifier.includes('@')) {
			const { data, error } = await supabase.rpc('auth_resolve_email', { identifier });
			if (error || !data) throw new Error('Usuario no encontrado');
			email = data;
		}
		return supabase.auth.signInWithPassword({ email, password });
	},
	// OAuth providers (requires enabling in Supabase dashboard)
	signInWithOAuth: (provider) => supabase.auth.signInWithOAuth({ provider }),
	// Phone OTP (requires phone auth enabled)
	signInWithPhoneOtp: (phone) => supabase.auth.signInWithOtp({ phone }),
	verifyPhoneOtp: ({ phone, token }) => supabase.auth.verifyOtp({ phone, token, type: 'sms' }),
	signOut: () => supabase.auth.signOut(),
};
